<ds-dialog [isCustomBody]="true">
  <ng-container dsDialogBody>
    <div class="root">
      <div class="header">
        <div class="title">{{ 'skyproCommunicationReportDialog.title' | transloco | skyUiTypograf }}</div>
        <div class="subtitle">{{ 'skyproCommunicationReportDialog.subtitle' | transloco | skyUiTypograf }}</div>
      </div>

      <div class="content">
        <skypro-message-request
          [needSaveInProgressText]="false"
          [showAuthorData]="false"
          [allowAttachments]="false"
          [isLoading]="isSending"
          [placeholder]="'skyproCommunicationReportDialog.placeholder' | transloco | skyUiTypograf"
          [validationError]="validationError && 'skyproCommunicationReportDialog.' + validationError | transloco | skyUiTypograf"
          (submit)="sendReport($event)"
        ></skypro-message-request>
      </div>
    </div>
  </ng-container>
</ds-dialog>
